import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const FieldSet = (props?: any) => (
  <fieldset {...props} className={styles.fieldSet} />
);

(FieldSet as any).displayName = 'FieldSet';

(FieldSet as any).propTypes = {
  /**
    * What to render inside the FieldSet
    */
  children: PropTypes.node.isRequired,
};

export default FieldSet;
